import React, { useState, useEffect, } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation, useParams, Link, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { ajouteOffre } from '../Redux/actions/actionOffre';
import { makeStyles } from '@material-ui/core/styles';
import Pagination from '@material-ui/lab/Pagination';
import SliderRange from '@material-ui/core/Slider';
import Slider from "react-slick";
import Spinner from "react-bootstrap/Spinner";
import Hero from '../components/Hero';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import noImage from "../Image/no-image.jpg";
import no_data from "../Image/no_data.png";
import { BASE_URL } from "../Utils/base_url";
import '../Css/rechercheSansCritere.css';
import { RechercheRequest, AfficheDataRequest } from '../Api/HomeApi';
import { AfficheHero } from '../Api/HomeApi';

const useStyles = makeStyles({
  root: {
    width: "100%"
  },
  thumb: {
    color: '#4ba7cc'
  },
  rail: {
    color: 'rgba(0,0,0,.26)',
  },
  track: {
    color: '#4ba7cc',
  }
});
const SearchSansCritere = () => {

  const [dataRestaurant, setDataRestaurant] = useState([]);
  const [allData, setAllData] = useState([]);
  const [totalData, setTotalData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showPaginate, setShowPaginate] = useState(true);
  const [totalPage, setTotalPage] = useState();
  const [page, setPage] = useState(1);

  const [imageUrl, setImageUrl] = useState('');
  const [imageLoad, setImageLoad] = useState(false);

  const [openDropDown, setOpenDropDown] = useState(false);


  const [visibility, setVisibility] = useState(4);

  const [visibilityFilter, setVisibilityFilter] = useState([
    { id: 1, name: "promotion" },
    { id: 2, name: "prix" },
    { id: 3, name: "note" },
    { id: 4, name: "typeCuisine" },
    { id: 5, name: "cadre" },
    { id: 6, name: "regime" },
    { id: 7, name: "plat" },
    { id: 8, name: "menue" },
    { id: 9, name: "service" },
    { id: 10, name: "payement" },
  ])

  const [promotion, setPromotion] = useState([
    { id: 2, name: 'Promo -50%' },
    { id: 3, name: 'Promo -40%' },
    { id: 4, name: 'Promo -30%' },
    { id: 5, name: 'Promo -20%' },
    { id: 6, name: 'Promo -10%' }
  ]);





  useEffect(() => {
    setImageLoad(true);
    AfficheHero().then(function (response) {
      setImageUrl(response.data.donner[0].imageUrl);
      localStorage.setItem('urlHero', response.data.donner[0].imageUrl);
    }).catch(function (error) {
      console.log(error);
    }).finally(function () {
      setImageLoad(false);
    });

  }, []);


  const [visibilitePromotion, setVisibilitePromotion] = useState(4);

  const [prix, setPrix] = useState([100, 100000]);

  const [note, setNote] = useState([0, 20]);


  const [typeCuisine, setTypeCuisine] = useState([]);


  const [visibiliteTypeCuisine, setVisibiliteTypeCuisine] = useState(4);



  const [cadre, setCadre] = useState([]);

  const [visibiliteCadre, setVisibiliteCadre] = useState(4);



  const [regime, setRegime] = useState([]);

  const [visibiliteRegime, setVisibiliteRegime] = useState(4);




  const [plat, setPlat] = useState([]);

  const [visibilitePlat, setVisibilitePlat] = useState(4);


  const [menue, setMenue] = useState([]);

  const [visibiliteMenue, setVisibiliteMenue] = useState(4);


  const [service, setService] = useState([]);

  const [visibiliteService, setVisibiliteService] = useState(4);



  const [payement, setPayement] = useState([]);

  const [visibilitePayement, setVisibilitePayement] = useState(4);


  const [promoFilter, setPromoFilter] = useState(null);
  const [cuisineFilter, setCuisineFilter] = useState(null);
  const [cadreFilter, setCadreFilter] = useState(null);
  const [regimeFilter, setRegimeFilter] = useState(null);
  const [platFilter, setPlatFilter] = useState(null);
  const [menuFilter, setMenuFilter] = useState(null);
  const [serviceFilter, setServiceFilter] = useState(null);
  const [payementFilter, setPayementFilter] = useState(null);
  const [statusPrix, setStatusPrix] = useState(false);
  const [statusNote, setStatusNote] = useState(false);


  const classes = useStyles();

  let location = useLocation();
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const { ou, qoui } = useParams();

  useEffect(() => {
    RequestData();
    RequestResto();
    if (totalData < 4) {
      setShowPaginate(false);
    } else {
      setShowPaginate(true);
    }
  }, [ou, qoui, totalData]);


  useEffect(() => {
    RequestFilter();
  }, [promoFilter, cuisineFilter, cadreFilter, regimeFilter, platFilter, menuFilter, serviceFilter, payementFilter, prix, note, statusPrix, statusNote]);



  const RequestData = () => {
    setLoading(true);
    AfficheDataRequest().then(function (response) {
      const dataCuisine = [];
      const dataCadre = [];
      const dataRegimeAlimentaire = [];
      const dataPlat = [];
      const dataMenue = [];
      const dataService = [];
      const dataPayement = [];

      response.data.donner.cuisine.forEach((el, index) => {
        const newType = { id: index + 1, name: el.libelle };

        // Vérifier si l'élément avec le même id existe déjà dans typeCuisine
        const typeExists = dataCuisine.find((item) => item.name === newType.name);

        // Si l'élément n'existe pas, l'ajouter à typeCuisine
        if (!typeExists) {
          dataCuisine.push(newType);
        }
      });

      response.data.donner.cadre.forEach((el, index) => {
        const newType = { id: index + 1, name: el.libelle };

        // Vérifier si l'élément avec le même id existe déjà dans typeCuisine
        const typeExists = dataCadre.find((item) => item.name === newType.name);

        // Si l'élément n'existe pas, l'ajouter à typeCuisine
        if (!typeExists) {
          dataCadre.push(newType);
        }
      });



      response.data.donner.regimeAlimentaire.forEach((el, index) => {
        const newType = { id: index + 1, name: el.libelle };

        // Vérifier si l'élément avec le même id existe déjà dans typeCuisine
        const typeExists = dataRegimeAlimentaire.find((item) => item.name === newType.name);

        // Si l'élément n'existe pas, l'ajouter à typeCuisine
        if (!typeExists) {
          dataRegimeAlimentaire.push(newType);
        }
      });


      response.data.donner.plat.forEach((el, index) => {
        const newType = { id: index + 1, name: el.libelle };

        // Vérifier si l'élément avec le même id existe déjà dans typeCuisine
        const typeExists = dataPlat.find((item) => item.name === newType.name);

        // Si l'élément n'existe pas, l'ajouter à typeCuisine
        if (!typeExists) {
          dataPlat.push(newType);
        }
      });


      response.data.donner.menu.forEach((el, index) => {
        const newType = { id: index + 1, name: el.nomMenu };

        // Vérifier si l'élément avec le même id existe déjà dans typeCuisine
        const typeExists = dataMenue.find((item) => item.name === newType.name);

        // Si l'élément n'existe pas, l'ajouter à typeCuisine
        if (!typeExists) {
          dataMenue.push(newType);
        }
      });


      response.data.donner.service.forEach((el, index) => {
        const newType = { id: index + 1, name: el.libelle };

        // Vérifier si l'élément avec le même id existe déjà dans typeCuisine
        const typeExists = dataService.find((item) => item.name === newType.name);

        // Si l'élément n'existe pas, l'ajouter à typeCuisine
        if (!typeExists) {
          dataService.push(newType);
        }
      });

      response.data.donner.payement.forEach((el, index) => {
        const newType = { id: index + 1, name: el.libelle };

        // Vérifier si l'élément avec le même id existe déjà dans typeCuisine
        const typeExists = dataPayement.find((item) => item.name === newType.name);
        // Si l'élément n'existe pas, l'ajouter à typeCuisine
        if (!typeExists) {
          dataPayement.push(newType);
        }
      });

      setTypeCuisine(dataCuisine);
      setCadre(dataCadre);
      setRegime(dataRegimeAlimentaire);
      setPlat(dataPlat);
      setMenue(dataMenue);
      setService(dataService);
      setPayement(dataPayement);

    }).catch(function (error) {
      console.log(error);
    }).finally(function () {
      setLoading(false);
    });
  }


  const RequestResto = (value = null) => {
    let dataPage = value === null ? page : value;
    setLoading(true);
    const data = { ou: ou !== "" && ou !== "..." ? ou : "", quoi: qoui !== "" && qoui !== "..." ? qoui : "", quand: "", heure: "", personne: "" };
    RechercheRequest(dataPage, data).then(function (response) {
      setDataRestaurant(response.data.donner);
      setTotalData(response.data.totalRows)
      setTotalPage(response.data.totalPage);
      setAllData(response.data.totalData);
    }).catch(function (error) {
      console.log(error);
    }).finally(function () {
      setLoading(false);
    });
  }




  const handleLoadPromo = () => {
    setVisibilitePromotion(visibilitePromotion + 4);
  }


  const handleLoadTypeCuisine = () => {
    setVisibiliteTypeCuisine(visibiliteTypeCuisine + 4);
  }


  const handleLoadCadre = () => {
    setVisibiliteCadre(visibiliteCadre + 4);
  }

  const handleLoadRegime = () => {
    setVisibiliteRegime(visibiliteRegime + 4);
  }

  const handleLoadPlat = () => {
    setVisibilitePlat(visibilitePlat + 4);
  }


  const handleLoadMenue = () => {
    setVisibiliteMenue(visibiliteMenue + 4);
  }


  const handleLoadService = () => {
    setVisibiliteService(visibiliteService + 4);
  }

  const handleLoadPayement = () => {
    setVisibilitePayement(visibilitePayement + 4);
  }


  const handleLoadVisibility = () => {
    setVisibility(visibility + 4);
  }

  const valueNotes = (notes) => {
    const note = safeParseFloat(notes.reduce(
      (prevNote, currentNote) => prevNote + parseInt(currentNote.note),
      0
    ) / notes.length);

    return note;
  }


  const valuetext = (value) => {
    return `${value}`;
  }

  const valueNote = (value) => {
    return `${value}`;
  }

  const resultPromo = (data, name) => {
    const dataValue = [];
    data.forEach((el) => {
      const existe = el.promotions.find((item) => item.libelle === name);
      if (existe) {
        return dataValue.push(el);
      }
    });

    return dataValue;
  }


  const resultCuisine = (data) => {
    let dataValue = [];
    data.forEach((el) => {
      const existe = el.typeCuisines.find((item) => item.libelle === cuisineFilter);
      if (existe) {
        return dataValue.push(el);
      }
    });
    return dataValue;
  }




  const resultCadre = (data) => {
    let dataValue = [];
    data.forEach((el) => {
      const existe = el.cadreAmbiances.find((item) => item.libelle === cadreFilter);
      if (existe) {
        return dataValue.push(el);
      }
    });
    return dataValue;
  }

  const resultRegime = (data) => {
    let dataValue = [];
    data.forEach((el) => {
      const existe = el.regimeAlimentaires.find((item) => item.libelle === regimeFilter);
      if (existe) {
        return dataValue.push(el);
      }
    });

    return dataValue;
  }

  const resultPlat = (data) => {
    let dataValue = [];
    data.forEach((el) => {
      const existe = el.plats.find((item) => item.libelle === platFilter);
      if (existe) {
        return dataValue.push(el);
      }
    });
    return dataValue;
  }

  const resultMenu = (data) => {
    let dataValue = [];
    data.forEach((el) => {
      const existe = el.menus.find((item) => item.nomMenu === menuFilter);
      if (existe) {
        return dataValue.push(el);
      }
    });
    return dataValue;
  }

  const resultService = (data) => {
    let dataValue = [];
    data.forEach((el) => {
      const existe = el.serviceRestaurant.find((item) => item.libelle === serviceFilter);
      if (existe) {
        return dataValue.push(el);
      }
    });
    return dataValue;
  }

  const resultPayement = (data) => {
    let dataValue = [];
    data.forEach((el) => {
      const existe = el.payements.find((item) => item.libelle === payementFilter);
      if (existe) {
        return dataValue.push(el);
      }
    });
    return dataValue;
  }


  const RequestFilter = () => {
    let updatedList = allData;

    if (promoFilter !== null) {
      if (promoFilter === 'Promo -50%') {
        updatedList = resultPromo(updatedList, "Promotion de -50%");
      } else if (promoFilter === 'Promo -40%') {
        updatedList = resultPromo(updatedList, "Promotion de -40%");
      } else if (promoFilter === 'Promo -30%') {
        updatedList = resultPromo(updatedList, "Promotion de -30%");
      } else if (promoFilter === 'Promo -20%') {
        updatedList = resultPromo(updatedList, "Promotion de -20%");

      } else if (promoFilter === 'Promo -10%') {
        updatedList = resultPromo(updatedList, "Promotion de -10%");
      }
    }


    if (cuisineFilter !== null) {
      updatedList = resultCuisine(updatedList);
    }

    if (cadreFilter !== null) {
      updatedList = resultCadre(updatedList);
    }

    if (regimeFilter !== null) {
      updatedList = resultRegime(updatedList);
    }

    if (platFilter !== null) {
      updatedList = resultPlat(updatedList);
    }

    if (menuFilter !== null) {
      updatedList = resultMenu(updatedList);
    }

    if (serviceFilter !== null) {
      updatedList = resultService(updatedList);
    }
    if (payementFilter !== null) {
      updatedList = resultPayement(updatedList);
    }
    if (statusPrix) {
      updatedList = updatedList.filter((el) => el.prixMoyenne[0]?.prix > prix[0] && el.prixMoyenne[0]?.prix < prix[1]);
    }
    if (statusNote) {
      updatedList = updatedList.filter((el) => valueNotes(el.notes) > note[0] && valueNotes(el.notes) < note[1]);
    }

    setDataRestaurant(updatedList);
  }


  const handleChangePrix = (event, newValue) => {
    setStatusPrix(true);
    setPrix(newValue);
  }

  const handleChangeNote = (event, newValue) => {
    setStatusNote(true);
    setNote(newValue);
  }


  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    pauseOnHover: true,
    speed: 2000,
    autoplaySpeed: 8000,
    swipeToSlide: true,
  };






  const viewPromotion = (promo) => {
    const existePromo50 = promo.find((el) => el.libelle === "Promotion de -50%");
    const existePromo40 = promo.find((el) => el.libelle === "Promotion de -40%");
    const existePromo30 = promo.find((el) => el.libelle === "Promotion de -30%");
    const existePromo20 = promo.find((el) => el.libelle === "Promotion de -20%");
    const existePromo10 = promo.find((el) => el.libelle === "Promotion de -10%");
    const existePromoSpecial = promo.find((el) => el.libelle === "Promotion : Menu spécial");

    if (existePromo50) {
      return (<label>-50%</label>);
    } else if (existePromo40) {
      return (<label>-40%</label>);
    } else if (existePromo30) {
      return (<label>-30%</label>);
    } else if (existePromo20) {
      return (<label>-20%</label>);
    } else if (existePromo10) {
      return (<label>-10%</label>);
    } else if (existePromoSpecial) {
      return (<label>Spécial</label>);

    } else {
      return (<p>Pas de promotion ...</p>);
    }


  }

  const safeParseFloat = (str) => {
    const value = Number.parseFloat(str);

    return Number.isNaN(value) ? 0 : value;
  };

  const DataPromotion = (item) => {
    const existePromo50 = item.promotions.find((el) => el.libelle === "Promotion de -50%");
    const existePromo40 = item.promotions.find((el) => el.libelle === "Promotion de -40%");
    const existePromo30 = item.promotions.find((el) => el.libelle === "Promotion de -30%");
    const existePromo20 = item.promotions.find((el) => el.libelle === "Promotion de -20%");
    const existePromo10 = item.promotions.find((el) => el.libelle === "Promotion de -10%");
    const existePromoSpecial = item.promotions.find((el) => el.libelle === "Promotion : Menu spécial");

    if (existePromo50) {
      return existePromo50;
    } else if (existePromo40) {
      return existePromo40;
    } else if (existePromo30) {
      return existePromo30;
    } else if (existePromo20) {
      return existePromo20;
    } else if (existePromo10) {
      return existePromo10;
    } else if (existePromoSpecial) {
      return existePromoSpecial;
    }


  }



  const handleReserver = (event, item) => {
    if (!localStorage.getItem('tokenClient')) {
      event.preventDefault();
      navigate("/loginClient");
    } else {
      const date = new Date();
      const au = new Date(item.creneauPromos[0]?.au);
      if (au.getFullYear() >= date.getFullYear() && parseInt(au.getMonth() + 1) >= parseInt(date.getMonth() + 1) && au.getDate() >= date.getDate()) {
        dispatch(ajouteOffre(DataPromotion(item)));
        localStorage.setItem('offre', JSON.stringify(DataPromotion(item)));
      }

    }
  }


  const viewDataFilter = (item, index) => {


    const notes = safeParseFloat(
      item?.notes.reduce(
        (prevNote, currentNote) => prevNote + parseInt(currentNote.note),
        0
      ) / item.notes.length
    );

    return (<div className='content-resultFilter' key={index} onClick={() => setOpenDropDown(false)}>
      <div className='row'>
        <div className='col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4'>
          <div className='image_slider'>
            <Slider {...settings}>
              {item.photos.map((el, i) => {
                return (
                  <div className='image' key={i}>
                    <img
                      src={
                        item.photos.length === 0
                          ? noImage
                          : BASE_URL + el.urlPhoto
                      }
                      alt="logo restaurant"
                    />
                  </div>
                )
              })}


            </Slider>
          </div>
        </div>
        <div className='col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4'>
          <div className='apropos_result'>
            <h3 className='cuisine text-center'>Cuisine {item.typeCuisines[0]?.libelle}</h3>
            <Link to={`/restoPage/${item.id}`} className="resto_link" title="restaurant page"> <h3 className='nom_resto text-center'>{item.nomRestaurant}</h3></Link>
            <div className='d-flex justify-content-center'>
              <span className='adresse'><i className='fa fa-map-marker'></i> {item.adresse}</span>
            </div>
            <div className='apropos_Footer'>
              <span className='prix'> <i className='fa fa-bookmark'></i> PM : {item.prixMoyenne[0]?.prix} Ar</span>
              {item.promotions.length !== 0 ?
                <span className='reduction'> <i className='fa fa-bullhorn'></i>  {viewPromotion(item.promotions)}</span> : ''}

            </div>
          </div>
        </div>
        <div className='col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4'>
          <div className='creneau_resultat'>
            <div className='d-flex justify-content-center'>
              <div className='note_nbrAvis'>
                <div>
                  <div className='note_filter'>Note/<span>{notes.toFixed(2)}</span></div>
                  <div className='avis_filter'>Avis/<span>{item.avis.length}</span></div>
                </div>
              </div>
            </div>
            <div className='creneau_liste d-flex justify-content-center'>
              <Link to={`/reserverSansCritere/${item.id}`} title="reserver" className='reserver_link' onClick={(e) => handleReserver(e, item)}><span>Réserver</span></Link>
            </div>
          </div>
        </div>
      </div>
    </div>)
  }


  const handlePage = (event, value) => {
    setPage(value);
    RequestResto(value);
  }

  const handleDrop = () => {
    setOpenDropDown(!openDropDown);
  }


  const handleDeCroissonNote = () => {
    const sorted = [...dataRestaurant].sort((a, b) => parseFloat(valueNote(a.notes)) < parseFloat(valueNotes(b.notes)) ? 1 : -1);
    setDataRestaurant(sorted);

  }

  const valuePromo = (promo) => {
    const existePromo50 = promo.find((el) => el.libelle === "Promotion de -50%");
    const existePromo40 = promo.find((el) => el.libelle === "Promotion de -40%");
    const existePromo30 = promo.find((el) => el.libelle === "Promotion de -30%");
    const existePromo20 = promo.find((el) => el.libelle === "Promotion de -20%");
    const existePromo10 = promo.find((el) => el.libelle === "Promotion de -10%");
    const existePromoSpecial = promo.find((el) => el.libelle === "Promotion : Menu spécial");

    if (existePromo50) {
      return 50;
    } else if (existePromo40) {
      return 40;
    } else if (existePromo30) {
      return 30;
    } else if (existePromo20) {
      return 20;
    } else if (existePromo10) {
      return 10;
    } else if (existePromoSpecial) {
      return 1;
    } else {
      return 0;
    }

  }

  const handleDeCroissonPromotion = () => {
    const sorted = [...dataRestaurant].sort((a, b) => valuePromo(a.promotions) > valuePromo(b.promotions) ? 1 : -1);
    setDataRestaurant(sorted);
  }

  const handleNouvaux = () => {
    const sorted = dataRestaurant.filter((el) => el.reservations.length <= 5);
    setDataRestaurant(sorted);
  }

  const handleReset = () => {
    RequestResto();
  }



  const hanlePromo = (name) => {
    setPromoFilter(name);

  }

  const deletePromoFilter = () => {
    setPromoFilter(null);
  }

  const deletePrixFilter = () => {
    setStatusPrix(false);
  }

  const deleteNoteFilter = () => {
    setStatusNote(false);
  }

  const handleCuisine = (name) => {
    setCuisineFilter(name);
  }

  const deleteCuisineFilter = () => {
    setCuisineFilter(null);
  }

  const handleCadre = (name) => {
    setCadreFilter(name);
  }

  const deleteCadreFilter = () => {
    setCadreFilter(null);

  }

  const handleRegime = (name) => {
    setRegimeFilter(name);
  }

  const deleteRegimeFilter = () => {
    setRegimeFilter(null);

  }

  const handlePlat = (name) => {
    setPlatFilter(name);
  }

  const deletePlatFilter = () => {
    setPlatFilter(null);
  }

  const handleMenu = (name) => {
    setMenuFilter(name);
  }

  const deleteMenuFilter = () => {
    setMenuFilter(null);
  }

  const handleService = (name) => {
    setServiceFilter(name);
  }

  const deleteServiceFilter = () => {
    setServiceFilter(null);
  }

  const handlePayement = (name) => {
    setPayementFilter(name);
  }

  const deletePayementFilter = () => {
    setPayementFilter(null);
  }

  const handleDeleteTous = () => {
    setPromoFilter(null);
    setStatusPrix(false);
    setStatusNote(false);
    setCuisineFilter(null);
    setCadreFilter(null);
    setRegimeFilter(null);
    setPlatFilter(null);
    setMenuFilter(null);
    setServiceFilter(null);
    setPayementFilter(null);
    setDataRestaurant([]);
    setAllData([]);
    RequestResto(1);

  }




  return (
    <div>
      <Helmet>
        <title>Recherche</title>
        <meta name='description' content='Recherche sans critère.' />
        <link rel='canonical' href={location.pathname} />
      </Helmet>
      <NavBar />
      <div className="rechercheSansCritere">
        <div className='content_recherche_sans_Critere'>
          <Hero ou={ou} qoui={qoui} date="" heure="" personne="" imageLoad={imageLoad} imageUrl={imageUrl} />
          <div className='row'>
            <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
              <div className='filter'>
                <div className='ma_selection'>
                  <div className='d-flex justify-content-between'>
                    <h2>Ma sélection</h2>
                    {promoFilter !== null || statusPrix !== false || statusNote !== false || cuisineFilter !== null || cadreFilter !== null ||
                      regimeFilter !== null || platFilter !== null || menuFilter !== null || serviceFilter !== null || payementFilter !== null ?
                      <button className='btn btn_Tout_suprimer' onClick={handleDeleteTous}>Tout suprimer</button>
                      : ""
                    }

                  </div>
                </div>
                <div className='liste_ma_selection'>
                  {promoFilter !== null ?
                    <div className='content_liste'>
                      <span>_ {promoFilter}</span>
                      <button className='btn btn_suprimer' onClick={deletePromoFilter}>X</button>
                    </div>
                    : ""}
                  {statusPrix !== false ?
                    <div className='content_liste'>
                      <span>_ Prix entrer {prix[0]} Ar à {prix[1]} Ar</span>
                      <button className='btn btn_suprimer' onClick={deletePrixFilter}>X</button>
                    </div>
                    : ""}

                  {statusNote !== false ?
                    <div className='content_liste'>
                      <span>_ Note entrer {note[0]} à {note[1]}</span>
                      <button className='btn btn_suprimer' onClick={deleteNoteFilter}>X</button>
                    </div>
                    : ""}

                  {cuisineFilter !== null ?
                    <div className='content_liste'>
                      <span>_ Cuisine {cuisineFilter}</span>
                      <button className='btn btn_suprimer' onClick={deleteCuisineFilter}>X</button>
                    </div>
                    : ""}

                  {cadreFilter !== null ?
                    <div className='content_liste'>
                      <span>_ Cadre {cadreFilter}</span>
                      <button className='btn btn_suprimer' onClick={deleteCadreFilter}>X</button>
                    </div>
                    : ""}

                  {regimeFilter !== null ?
                    <div className='content_liste'>
                      <span>_ Regime {regimeFilter}</span>
                      <button className='btn btn_suprimer' onClick={deleteRegimeFilter}>X</button>
                    </div>
                    : ""}

                  {platFilter !== null ?
                    <div className='content_liste'>
                      <span>_ Plat {platFilter}</span>
                      <button className='btn btn_suprimer' onClick={deletePlatFilter}>X</button>
                    </div>
                    : ""}


                  {menuFilter !== null ?
                    <div className='content_liste'>
                      <span>_ Menu {menuFilter}</span>
                      <button className='btn btn_suprimer' onClick={deleteMenuFilter}>X</button>
                    </div>
                    : ""}



                  {serviceFilter !== null ?
                    <div className='content_liste'>
                      <span>_ Service {serviceFilter}</span>
                      <button className='btn btn_suprimer' onClick={deleteServiceFilter}>X</button>
                    </div>
                    : ""}

                  {payementFilter !== null ?
                    <div className='content_liste'>
                      <span>_ Payement {payementFilter}</span>
                      <button className='btn btn_suprimer' onClick={deletePayementFilter}>X</button>
                    </div>
                    : ""}


                </div>

                <div className='item_filter'>
                  {visibilityFilter.slice(0, visibility).map((el, i) => {
                    if (el.name === "promotion") {
                      return (<div key={i}>
                        <hr />
                        <h2>Promotion</h2>
                        <div className='item_promotion'>
                          {promotion.slice(0, visibilitePromotion).map((el, index) => {
                            return (
                              <div className="form-check" key={index}>
                                <label className="form-check-label" htmlFor={"flexCheckChecked" + el.id}>
                                  {el.name}
                                </label>
                                <input className="form-check-input" type="radio" onChange={() => hanlePromo(el.name)} name="flexRadioDefault" id={"flexCheckChecked" + el.id} />
                              </div>
                            );
                          })}
                          {promotion.length > 4 ? promotion.length <= visibilitePromotion ? '' : <div className='d-flex justify-content-center'><span onClick={handleLoadPromo} className="plus">Plus ...</span> </div> : ''}
                        </div>

                      </div>)
                    } else if (el.name === "prix") {
                      return (<div key={i}>
                        <hr />
                        <h2>Prix Moyenne</h2>
                        <div className='item_prix'>
                          <div className={classes.root}>
                            <SliderRange
                              value={prix}
                              onChange={handleChangePrix}
                              valueLabelDisplay="on"
                              min={100}
                              max={100000}
                              classes={{
                                thumb: classes.thumb,
                                rail: classes.rail,
                                track: classes.track
                              }}
                              aria-labelledby="range-slider"
                              getAriaValueText={valuetext}
                              valueLabelFormat={valuetext}
                            />
                          </div>
                        </div>

                      </div>)
                    } else if (el.name === "note") {
                      return (<div key={i}>
                        <hr />
                        <h2>Note</h2>
                        <div className='item_note'>
                          <div className={classes.root}>
                            <SliderRange
                              value={note}
                              onChange={handleChangeNote}
                              valueLabelDisplay="on"
                              min={0}
                              max={20}
                              classes={{
                                thumb: classes.thumb,
                                rail: classes.rail,
                                track: classes.track
                              }}
                              aria-labelledby="range-slider"
                              getAriaValueText={valueNote}
                              valueLabelFormat={valueNote}
                            />
                          </div>
                        </div>

                      </div>)
                    } else if (el.name === "typeCuisine") {
                      return (
                        <div key={i}>
                          <hr />
                          <h2>Type de cuisine</h2>
                          <div className='item_typeCuisine'>
                            {typeCuisine.slice(0, visibiliteTypeCuisine).map((el, index) => {
                              return (
                                <div className="form-check" key={index}>
                                  <label className="form-check-label" htmlFor={"flexCheckCheckedType" + el.id}>
                                    {el.name}
                                  </label>
                                  <input className="form-check-input" type="radio" onChange={() => handleCuisine(el.name)} name="flexRadioDefault" id={"flexCheckCheckedType" + el.id} />
                                </div>
                              );
                            })}
                            {typeCuisine.length > 4 ? typeCuisine.length <= visibiliteTypeCuisine ? '' : <div className='d-flex justify-content-center'><span onClick={handleLoadTypeCuisine} className="plus">Plus ...</span> </div> : ''}
                          </div>

                        </div>
                      )
                    } else if (el.name === "cadre") {
                      return (
                        <div key={i}>
                          <hr />
                          <h2>Cadre et ambiance</h2>
                          <div className='item_cadre'>
                            {cadre.slice(0, visibiliteCadre).map((el, index) => {
                              return (
                                <div className="form-check" key={index}>
                                  <label className="form-check-label" htmlFor={"flexCheckCheckedCadre" + el.id}>
                                    {el.name}
                                  </label>
                                  <input className="form-check-input" type="radio" onChange={() => handleCadre(el.name)} name="flexRadioDefault" id={"flexCheckCheckedCadre" + el.id} />
                                </div>
                              );
                            })}
                            {cadre.length > 4 ? cadre.length <= visibiliteCadre ? '' : <div className='d-flex justify-content-center'><span onClick={handleLoadCadre} className="plus">Plus ...</span> </div> : ''}
                          </div>
                        </div>
                      )
                    } else if (el.name === "regime") {
                      return (<div key={i}>
                        <hr />
                        <h2>Régime alimentaire spécifique</h2>
                        <div className='item_regime'>
                          {regime.slice(0, visibiliteRegime).map((el, index) => {
                            return (
                              <div className="form-check" key={index}>
                                <label className="form-check-label" htmlFor={"flexCheckCheckedRegime" + el.id}>
                                  {el.name}
                                </label>
                                <input className="form-check-input" type="radio" onChange={() => handleRegime(el.name)} name="flexRadioDefault" id={"flexCheckCheckedRegime" + el.id} />
                              </div>
                            );
                          })}
                          {regime.length > 4 ? regime.length <= visibiliteRegime ? '' : <div className='d-flex justify-content-center'><span onClick={handleLoadRegime} className="plus">Plus ...</span> </div> : ''}
                        </div>

                      </div>)
                    } else if (el.name === "plat") {
                      return (<div key={i}>
                        <hr />
                        <h2>Plats </h2>
                        <div className='item_plat'>
                          {plat.slice(0, visibilitePlat).map((el, index) => {
                            return (
                              <div className="form-check" key={index}>
                                <label className="form-check-label" htmlFor={"flexCheckCheckedPlat" + el.id}>
                                  {el.name}
                                </label>
                                <input className="form-check-input" type="radio" onChange={() => handlePlat(el.name)} name="flexRadioDefault" id={"flexCheckCheckedPlat" + el.id} />
                              </div>
                            );
                          })}
                          {plat.length > 4 ? plat.length <= visibilitePlat ? '' : <div className='d-flex justify-content-center'><span onClick={handleLoadPlat} className="plus">Plus ...</span> </div> : ''}
                        </div>

                      </div>)
                    } else if (el.name === "menue") {
                      return (<div key={i}>
                        <hr />
                        <h2>Menus </h2>
                        <div className='item_plat'>
                          {menue.slice(0, visibiliteMenue).map((el, index) => {
                            return (
                              <div className="form-check" key={index}>
                                <label className="form-check-label" htmlFor={"flexCheckCheckedMenue" + el.id}>
                                  {el.name}
                                </label>
                                <input className="form-check-input" type="radio" onChange={() => handleMenu(el.name)} name="flexRadioDefault" id={"flexCheckCheckedMenue" + el.id} />
                              </div>
                            );
                          })}
                          {menue.length > 4 ? menue.length <= visibiliteMenue ? '' : <div className='d-flex justify-content-center'><span onClick={handleLoadMenue} className="plus">Plus ...</span> </div> : ''}
                        </div>

                      </div>)
                    } else if (el.name === "service") {
                      return (<div key={i}>
                        <hr />
                        <h2>Services</h2>
                        <div className='item_service'>
                          {service.slice(0, visibiliteService).map((el, index) => {
                            return (
                              <div className="form-check" key={index}>
                                <label className="form-check-label" htmlFor={"flexCheckCheckedService" + el.id}>
                                  {el.name}
                                </label>
                                <input className="form-check-input" type="radio" onChange={() => handleService(el.name)} name="flexRadioDefault" id={"flexCheckCheckedService" + el.id} />
                              </div>
                            );
                          })}
                          {service.length > 4 ? service.length <= visibiliteService ? '' : <div className='d-flex justify-content-center'><span onClick={handleLoadService} className="plus">Plus ...</span> </div> : ''}
                        </div>

                      </div>)
                    } else {
                      return (<div key={i}>
                        <hr />
                        <h2>Moyen de paiement</h2>
                        <div className='item_payement'>
                          {payement.slice(0, visibilitePayement).map((el, index) => {
                            return (
                              <div className="form-check" key={index}>
                                <label className="form-check-label" htmlFor={"flexCheckCheckedPayement" + el.id}>
                                  {el.name}
                                </label>
                                <input className="form-check-input" type="radio" onChange={() => handlePayement(el.name)} name="flexRadioDefault" id={"flexCheckCheckedPayement" + el.id} />
                              </div>
                            );
                          })}
                          {payement.length > 4 ? payement.length <= visibilitePayement ? '' : <div className='d-flex justify-content-center'><span onClick={handleLoadPayement} className="plus">Plus ...</span> </div> : ''}
                        </div></div>)
                    }
                  })}

                  {visibilityFilter.length > 4 ? visibilityFilter.length <= visibility ? '' : <div className='d-flex justify-content-end'><span onClick={handleLoadVisibility} className="plusCritere">Plus de critère</span> </div> : ''}
                </div>

              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9">
              <div className='resultProduitFilter'>
                <div className='header_result d-flex justify-content-between'>
                  <div className='nombre_result'>
                    <h2>Résultat de la recherche : {loading ? " chargement...":<span>{totalData !== null ? totalData : "0"} restaurants</span>} </h2>
                  </div>
                  {dataRestaurant.length !== 0 ?
                    <div className='filter_result'>
                      <button className='btn btn_trier' onClick={handleDrop}>Trier par :</button>
                    </div>
                    : ""}

                </div>
                <div className='col-xs-12 col-12 col-sm-12'>
                  <div className='d-flex justify-content-end'>
                    <div className={openDropDown === true ? "body-filter show" : "body-filter"}>
                      <div className="filter-content">
                        <div className="filter_titre">
                          <li className='filter_note'>Note</li>
                          <li className='filter_promotion'>Promotion</li>
                          <li className='filter_resto'>Restaurant</li>
                        </div>
                        <div className="filter-value">
                          <div className="body-valueNote">
                            <span className='ms-3' onClick={handleDeCroissonNote}>Décroissant</span>
                          </div>
                          <div className="body-valuePromotion">
                            <span className='ms-3' onClick={handleDeCroissonPromotion}>Décroissant</span>
                          </div>
                          <div className="body-valueRestaurant">
                            <span className='ms-3' onClick={handleNouvaux}>Nouvaux</span>
                          </div>
                        </div>
                      </div>
                      <div className="footer-value">
                        <div className="action">
                          <button className="btn btn_reinitialiser btn-sm" onClick={handleReset}>
                            Reinitialiser
                          </button>
                          <button className="btn btn_fermerFilter btn-sm" onClick={() => setOpenDropDown(false)}>
                            Fermer
                          </button>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                {loading ? (
                  // Spinner pendant le chargement
                  <div className="d-flex justify-content-center">
                    <Spinner
                      animation="border"
                      className="load"
                      variant="info"
                      size="md"
                    />
                  </div>
                ) : dataRestaurant.length > 0 ? (
                  // Affichage des résultats triés
                  [...dataRestaurant]
                    .sort((a, b) =>
                      a.nomRestaurant.toLowerCase() > b.nomRestaurant.toLowerCase() ? 1 : -1
                    )
                    .map((item, index) => viewDataFilter(item, index))
                ) : (
                  // Aucun résultat après chargement
                  <div className='d-flex justify-content-center'>
                    <div className='col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8'>
                      <div className='found-recherche'>
                        <div className='d-flex justify-content-center'>
                          <div className='found_img'>
                            <img src={no_data} alt="no data" />
                          </div>
                        </div>
                        <span>
                          « Aucun résultat correspondant à votre recherche.
                          Souhaitez-vous partager avec nous une bonne adresse ?
                          <Link to="/contact" title='contact'> Cliquez ici en nous donnant le plus d’informations sur « votre » restaurant </Link>,
                          Nous vous invitons à modifier vos critères de recherche »
                        </span>
                      </div>
                    </div>
                  </div>
                )}

                {promoFilter !== null || statusPrix !== false || statusNote !== false || cuisineFilter !== null || cadreFilter !== null ||
                  regimeFilter !== null || platFilter !== null || menuFilter !== null || serviceFilter !== null || payementFilter !== null ?
                  ""
                  : totalData !== 0 || totalData !== 1 ?
                    showPaginate && <div className='d-flex justify-content-center mt-4'>
                      <Pagination
                        shape="rounded"
                        count={Math.ceil(totalPage)}
                        onChange={handlePage}
                      />
                    </div>
                    : ''
                }

              </div>
            </div>
            <p className="version">Version 1</p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default SearchSansCritere